"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParkingDialog = ParkingDialog;
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _Public2 = _interopRequireDefault(require("@mui/icons-material/Public"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _models = require("../models");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ParkingDialog(_ref) {
  let {
    parking,
    ...props
  } = _ref;
  const network = parking?.network && _models.parkingNetworks[parking.network] || null;
  return /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    maxWidth: "md"
  }, props), /*#__PURE__*/_react.default.createElement(StyledDialogTitle, null, network && /*#__PURE__*/_react.default.createElement(StyledHeaderLogo, {
    title: network.title,
    url: network.icon
  }), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.poi.categories.parking_one"
  })), /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => props.onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, parking?.capacity && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    count: parking.capacity,
    i18nKey: "commons.parking.racks",
    values: {
      count: parking.capacity,
      capacity: parking.capacity
    }
  }), "\xA0\u2022\xA0"), parking?.locked && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.parking.locked"
  }), "\xA0\u2022\xA0"), parking?.sheltered && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.parking.sheltered"
  }), "\xA0\u2022\xA0"), parking?.supervised && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.parking.supervised"
  }), "\xA0\u2022\xA0"), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: parking?.free ? 'commons.parking.free' : 'commons.parking.toll'
  }))), parking?.website && /*#__PURE__*/_react.default.createElement(StyledDialogActions, null, /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: "primary",
    component: "a",
    href: parking.website,
    rel: "noreferrer",
    size: "small",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_Public2.default, null), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.website"
  }))));
}
const StyledDialogTitle = (0, _styledComponents.default)(_DialogTitle2.default)`
  && {
    padding-right: 46px;

    h2 {
      align-items: center;
      display: flex;
    }
  }
`;
const StyledHeaderLogo = _styledComponents.default.div`
  align-self: center;
  background-image: ${_ref2 => {
  let {
    url
  } = _ref2;
  return `url(${url})`;
}};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 48px;
  margin-right: 8px;
  width: 48px;
`;
const CloseButtonWrapper = _styledComponents.default.div`
  position: absolute;
  right: 8px;
  top: 8px;

  button {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;
const StyledDialogActions = (0, _styledComponents.default)(_DialogActions2.default)`
  svg {
    margin-right: 4px;
  }
`;